import { render } from "./PokedexInfo.vue?vue&type=template&id=c278a19c&scoped=true"
import script from "./PokedexInfo.vue?vue&type=script&lang=js"
export * from "./PokedexInfo.vue?vue&type=script&lang=js"

import "./PokedexInfo.vue?vue&type=style&index=0&id=c278a19c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c278a19c"]])

export default __exports__